export const clerkAttributes = ["id","name", "url", "categories", "uoM", "twelvePrice", "price", "list_price", "type", "shortText", "shortText", "in_stock", "inventory", "inventoryRed"];
export function clerkItemToUmItem(item){
    item.No = item.id.substr(3);
    item.Url = item.url;
    item.UnitPrice = item.list_price;
    item.ShortText = item.shortText;
    item.Description = item.name;
    item.UoM = item.uoM;
    item.Categories = item.categories.map(c=>({id:c}));
    item.Inventory = item.inventory;
    item.InventoryRed = item.inventoryRed;

    // var prices = [{MinQuantity : 1, UnitPrice: item.price}];
    var prices = [];
    if(item.price<item.list_price)
        prices.push({MinQuantity : 1, UnitPrice : item.price});

    if(item.twelvePrice>0 && item.twelvePrice<item.price)
        prices.push({MinQuantity : 12, UnitPrice : item.twelvePrice});
        
    item.SalePrices = prices;
    return item;
}